import React from 'react';

export default function MissingPage () {
  return (
    <div className="missing-page">
      Move along nothing to see here
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/MissingPage.js